import { render, staticRenderFns } from "./RequestCardUserReadOnly.vue?vue&type=template&id=2ec5ce86&scoped=true&"
import script from "./RequestCardUserReadOnly.vue?vue&type=script&lang=js&"
export * from "./RequestCardUserReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./RequestCardUserReadOnly.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RequestCardUserReadOnly.vue?vue&type=style&index=1&id=2ec5ce86&scoped=true&lang=css&"
import style2 from "./RequestCardUserReadOnly.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5ce86",
  null
  
)

export default component.exports